import { render } from "./AddressAutocomplete.vue?vue&type=template&id=4bccc9d0&scoped=true"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js"

import "./AddressAutocomplete.vue?vue&type=style&index=0&id=4bccc9d0&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bccc9d0"]])

export default __exports__